<template>
  <progress-steps :step="step" :steps="steps" />
</template>

<script>
import ProgressSteps from './ProgressSteps.vue'

export default {
  name: 'AppropriatenessSteps',

  components: {
    ProgressSteps
  },

  props: {
    step: Number
  },

  data: () => ({
    steps: [
      'Experience',
      'Knowledge',
      'Attitude',
      'Wealth',
      'Decision'
    ]
  })
}
</script>
